/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Browse_AsideInputs */

const en_help_browse_aside = /** @type {(inputs: Help_Browse_AsideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every article, grouped the way the app is.`)
};

const pl_help_browse_aside = /** @type {(inputs: Help_Browse_AsideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wszystkie artykuły, ułożone tak jak aplikacja.`)
};

/**
* | output |
* | --- |
* | "Every article, grouped the way the app is." |
*
* @param {Help_Browse_AsideInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const help_browse_aside = /** @type {((inputs?: Help_Browse_AsideInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Browse_AsideInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_help_browse_aside(inputs)
	return en_help_browse_aside(inputs)
});